export class NotEqualsError extends Error {
  constructor () {
    super('A senha e a confirmação devem ser iguais')
    this.name = 'NotEqualsError'
  }
}
